import { React, useState, useEffect } from "react";
import Menu from "../../nav/menu";
import Footer from "../../nav/footer";
import useMedia from "use-media";
import StylishHeader from '../../components/stylishHeader';
import LoadingScreenInline from '../../components/loadingInline.js';

import { mainDivStyle, mainDivMobileStyle,
  cardsStyle,
  columnStyle
  } from "./styles";
import { generalStyleDivs } from "../../styles.js";
import { textInResolution } from '../../multiFunctions';
import { title, body1, body2, body3, body4 } from "./text";
import { localfarmsList } from '../../endpoints-Calls/providers/index.js';

function LocalFarms() {
  const isLargeScreen = useMedia("(min-width: 601px)");
  const isSmallScreen = useMedia("(max-width: 600px)");
  const [listProviders, setListProviders] = useState([]);
  const [isLoadingContent, setIsLoadingContent] = useState(true);

  const screenSize = {
    width: window.screen.width,
    height: window.screen.height
  }
  const listImage = [{ url: "/img/colectors.jpg" }];

  let styleFontSize = {
    fontSize: textInResolution('medium', 'large', 'large', 'large', screenSize)
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await localfarmsList();
        if (result.isOk) {
          setListProviders(result.providersObj);
          setIsLoadingContent(false);
        } 
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div>
      <Menu />
      <div
        style={{
          backgroundColor: "#F4DFBB",
          justifyContent: "center",
          display: "flex",
        }} >
          
        {isLargeScreen && (
          <div style={mainDivStyle}>
              <div>
                <StylishHeader headerText={title} />
                
              </div>
              <div style={{ paddingTop: "10px", display: "flex", flexFlow: "colum" }}>
                <div
                  style={{
                    ...generalStyleDivs,
                    ...styleFontSize,
                    width: "50%",
                    padding: "10px",
                    display: "flex",
                    alignItems: "center"
                  }}>
                  <span  dangerouslySetInnerHTML={{ __html: body1 }}></span>
                </div>
                <div style={{ width: "50%", paddingLeft: "10px" }}>
                  <img
                    src={listImage[0].url}
                    style={{
                      width: "100%",
                      borderRadius: "12px",
                    }}
                    alt=""
                  />
                </div>
              </div>
            {isLoadingContent &&
              <>
                <br/>
                <LoadingScreenInline/>
                <br/>
              </>
            }
            {!isLoadingContent &&
              <div style={{ display: "flex", flexFlow: "row", paddingTop: "10px", marginBottom: "30px" }}>
                <div style={{ ...cardsStyle, width:"33%", height: "100%" }}>
                  <LocalFarmsInfo objIN={listProviders[0]} isLargeScreen={isLargeScreen} isSmallScreen={isSmallScreen}/>
                </div>
                <div style={{ ...cardsStyle, width:"33%", height: "100%" }}>
                  <LocalFarmsInfo objIN={listProviders[1]} isLargeScreen={isLargeScreen} isSmallScreen={isSmallScreen}/>
                </div>
                <div style={{ ...cardsStyle, width:"33%", height: "100%" }}>
                  <LocalFarmsInfo objIN={listProviders[2]} isLargeScreen={isLargeScreen} isSmallScreen={isSmallScreen}/>
                </div>
              </div>
            }
            <div style={{ width: "100%", ...styleFontSize }} >
                <div  style={{
                  ...generalStyleDivs,
                  padding: "10px",
                  display: "flex",
                  alignItems: "center",
                  height: "100%"
                }}
                >
                  {body2}<br/><br/>
                  {body3}<br/><br/>
                  {body4}<br/><br/>
                </div>
              </div>
          </div>
        )}
        {isSmallScreen && (
          <div style={mainDivMobileStyle}>
            <div style={{ paddingBottom: "20px" }}>
              <StylishHeader headerText={title} />
            </div>
            <div style={{ fontSize: "medium",
                  padding: "10px",
                  display: "flex",
                  alignItems: "center", ...generalStyleDivs }}>
                {body1}
            </div>
            <div style={{ width: "100%", paddingTop: "10px", paddingBottom: "10px" }}>
              <img
                src={listImage[0].url}
                style={{
                  width: "100%",
                  maxHeight: "250px",
                  borderRadius: "12px",
                }}
                alt=""
              />
            </div>
            <div style={{ fontSize: "medium",
                  padding: "10px",
                  display: "flex",
                  alignItems: "center", ...generalStyleDivs }}>
              <div style={{ ...columnStyle, fontSize: "medium",paddingTop: "15px" }}>{body2}</div>
            </div>
              <div style={{ fontSize: "medium" }}>
                <div style={{ ...cardsStyle, }}>
                  <LocalFarmsInfo objIN={listProviders[0]} isLargeScreen={isLargeScreen} isSmallScreen={isSmallScreen}/>
                </div>
              
                <div style={{ ...cardsStyle }}>
                  <LocalFarmsInfo objIN={listProviders[1]} isLargeScreen={isLargeScreen} isSmallScreen={isSmallScreen}/>
                </div>
                <div style={{ ...cardsStyle }}>
                  <LocalFarmsInfo objIN={listProviders[2]} isLargeScreen={isLargeScreen} isSmallScreen={isSmallScreen}/>
                </div>
              </div>
          </div>
        )}
        
      </div>
      <Footer />
    </div>
  );
}

export default LocalFarms;

function LocalFarmsInfo(props) {
  /* eslint-disable react/prop-types */
  let styleImg = {
    maxWigth: "300px",
    maxHeight: "200px",
    paddingTop: "10px",
    paddingBottom: "10px"
  }
  return (
    <>
      {props.objIN !== undefined && props.isLargeScreen &&
        <div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <img
              src={props.objIN.logoURL}
              style={{ ...styleImg }}
              alt=""
            />
          </div>
          <div style={{ paddingLeft: "5px", paddingRight: "5px", textAlign: "justify" }}>
            <span  dangerouslySetInnerHTML={{ __html: props.objIN.smallDescription }}></span>
          </div>
        </div>
      }
      {props.objIN !== undefined && props.isSmallScreen &&
      <div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <img
            src={props.objIN.logoURL}
            style={{ ...styleImg }}
            alt=""
          />
        </div>
        <div style={{ paddingLeft: "5px", paddingRight: "5px", paddingBottom: "5px", textAlign: "justify" }}>
          <span  dangerouslySetInnerHTML={{ __html: props.objIN.smallDescription }}></span>
        </div>
      </div>
      }
    </>
    
  )
}